(function Module() {
	'use strict';
	mySynch.controller('ReviewDraftReportV2_0Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'F360Service',
		'AuditService',
		'ApiFactory',
		'F360Constant',
		'F360ChartService',
		'CookieFactory',
		'$location',
		'$filter',
		'$window',
		'$anchorScroll',
		'MySynchFactory',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function ReviewDraftReportV2_0Controller($s,$rootScope,$interval,$q, f360Service, auditService,api,constant, ChartService,cookies, $location,$filter,$window,$anchorScroll,MSF,perfMetricSvc, perfContextSvc, log) {

			self.auditId = auditService.getAuditId($location.url());
			
			$s.peformanceContext = null;
			
			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();

			$s.isOnline = $rootScope.onLine;


			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};


			$s.overViewList = [];
			$s.auditAnswers = [];
			$s.auditQuestions = [];
			$s.auditQuestionsWithAnswers = [];

			$s.sectionsQuestionsAndAnswers = [];
			$s.structuredQuestionsAndAnswers = [];
			$s.followupItems = [];
			$s.actionItemGroups = [];
			$s.actionItems = [];

			$s.isEditingActionItemGroup = false;
			$s.isEditingActionItem = false;
			$s.currentActionItemGroup = {};
			$s.currentActionItem = {};
			$s.currentActionItemGroupRef = {};
			$s.currentActionItemRef = {};

			$s.actionItemGroupKeyErrorText = "";
			$s.actionItemGroupKeyFreeTextErrorText = "";
        

			$s.people = [];

			$s.auditApiVersion;


			$s.submitting = false;



			$s.codeFile = [];

			$s.actionItemGroupTmpl;
			$s.actionItemTmpl;

			let testActionItemGroup = {
				actionItemGroupKey: "Fertility",
				description: "test action group involving Fertility",
				actionItems: [],
				associatedMetrics: ""
			};

			let testAssociatedMetrics = [
				{
					name: "Pregnancy Rate RHA"
				},
				{
					name: "Conception Rate RHA"
				}
			];

			let testPeople = [{ personId: 1, fullName: "Mary Smith" }, { personId: 1080, fullName: "Matthew Doucet" }, { personId: 1077, fullName: "Brandon Dugan" }];

			let testActionItems = [
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,15)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,15),
					description: "This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. ",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"

				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,16)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,16),
					description: "This is a list of actions to complete to meet the goal.",
					personId: 1080,
					fullName: "Matthew Doucet",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,17)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,17),
					description: "Description goes here.",
					personId: 1080,
					fullName: "Matthew Doucet",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				}
			];


			

			$s.allMetGuidelineQuestions = [];
			$s.allOutsideGuidelineQuestions = [];
			$s.allMetGuidelineQuestionsWithGuidelines = [];
			$s.allOutsideGuidelineQuestionsWithGuidelines = [];
		  
		

			$s.defaultReportData = {"resultsWriteRptJson":{"formattedHighlights":"","nextEvaluationDate":"","comments":[{"category": "COMFRT","formattedComments":""},{"category": "NUTRIT","formattedComments":""},{"category": "DATAQUALITY","formattedComments":""},{"category": "REPROD","formattedComments":""},{"category": "DISEASE","formattedComments":""},{"category": "PERSON","formattedComments":""},{"category": "INFORM","formattedComments":""}]},"reviewDraftRptJson":{"reportDate":"","milkingCnt": null,"pregRate":null,"concRate":null,"reviewedReport":false,"actionItemGroups":[]}};
			$s.reportData = {};
			$s.report = angular.copy($s.defaultReportData);

		
			

				//--------- chart variables
				$s.overallSummaryPieChart = {
					chart: {},
					title: "",
					seriesData: [] 
				};
			
				$s.sectionBarChart = {
					chart: {},
					title: "",
					seriesData: []
				};
				$s.categoryBarChart = {
					chart: {},
					title: "",
					seriesData: []
				};
				
				$s.questionSectionsPieChartData = [];
		 		$s.codeFileCurrentF360CategoryApiVersions = [];
				$s.codeFileQuestionSections = [];
				$s.codeFileQuestionSectionSubheadings = [];
				$s.codeFileQuestionCategories = [];
				$s.codeFileQuestionSubCategories = [];
				$s.codeFileQuestionOrders = [];
				$s.codeFileQuestionSubtitles = [];

				
	
				
			//-------------------

			$s.currentTopAnchor = "";
			 
			$s.reportDate = moment().toDate();
			$s.authors = ""; 

			$s.pregRateQuestionId = 170;
			$s.concRateQuestionId = 153;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			// flag for that is set true when and update answers or publish audit call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

			$s.checkSyncStatusTimer = undefined;

			//------------------
			// TEMP CODE
            //------------------

			$s.setupTempFields = function setupTempFields(questions){

				_.forEach(questions,function(question){
					// target a set of questions for add bool "allowOptOut"
					  if(_.includes([2,3,13,14,24,25,35,36],_.get(question,'QuestionId'))){
							 _.set(question,'allowOptOut',true);
					  }else{
					   _.set(question,'allowOptOut',false);
					  }
		          
				      //COMFORT
					  if(_.includes([2,7,10,13,18,21,24,29,32,35,38,41,46,70,77,78,79,80],_.get(question,'QuestionId'))){
                               _.set(question,'Category','COMFRT');
							   if(_.includes([2,7,10,13],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','MGMT');
								_.set(question,'Subtitle','MGMT');
							   }

							   if(_.includes([18,21,24,29,32,35],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','FACILITY');
								_.set(question,'Subtitle','FACILITY');
							   }

							if(_.includes([38,41,46,70,77,78,79,80],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','OTHER');
								_.set(question,'Subtitle','OTHER');
							}
                             
				    	} 
					  // NUTR
					  if(_.includes([9,20,31,40,44,45],_.get(question,'QuestionId'))){
                           _.set(question,'Category','NUTRIT');
						   if(_.includes([9],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','FACILITY');
						   }

						   if(_.includes([20],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','WATER');
						   }

						if(_.includes([31],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','RATION');
						}
						if(_.includes([40],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','BCS');
						   }

						   if(_.includes([44],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MGMT');
						   }

						if(_.includes([45],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						}

                      // subtitles
						if(_.includes([9],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','WATER');
						}

						
						if(_.includes([20],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','BCS');
						}

						
						if(_.includes([31],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','MGMTFAC');
						}

						if(_.includes([40,44,45],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','RATION');
						}

					 } 
					  //DATAQLTY
					  if(_.includes([109,110,111,112,113,114,115,116,117,160,164,166,168,170,172,174],_.get(question,'QuestionId'))){
						_.set(question,'Category','DATAQUALITY');
						if(_.includes([109],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','REPROREC');
						   }
						   if(_.includes([110],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-RP');
						   }
						   if(_.includes([111],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-K');
						   }
						   if(_.includes([112],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MF');
						   }
						   if(_.includes([113],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MET');
						   }
						   if(_.includes([114],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-DA');
						   }
						   if(_.includes([115],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MAST');
						   }
						   if(_.includes([116],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','DYSTOCIA');
						   }
						   if(_.includes([117,160],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PNEUMONIA');
						   }
						   if(_.includes([164,166],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','LAMENESS');
						   }
						   if(_.includes([168,170],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TWIN');
						   }
						   if(_.includes([172,174],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','STILLBIRTH');
						   }

						   	// subtitles 
							   if(_.includes([109,110,111,112,113,114],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','REPROD');
							   }
							   if(_.includes([115,116,117,160,164,166,168,170,172,174],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','DISEASE');
							   }


					} 
					  //REPRO
					  if(_.includes([119,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
						_.set(question,'Category','REPROD');

						   if(_.includes([119],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PREG');
						   }
						   if(_.includes([121],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PREG-VWP');
						   }
						   if(_.includes([122],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','INSEM');
						   }
						   if(_.includes([123],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','INSEM-MO');
						   }
						   if(_.includes([124],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP');
						   }
						   if(_.includes([125],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-MO');
						   }
						   if(_.includes([126],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-LACT');
						   }
						   if(_.includes([127],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-SVC');
						   }
						   if(_.includes([128],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-TECH');
						   }
						   if(_.includes([129,130,131,132,133,134,135,136,137,138],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-SIRE');
						   }
						   if(_.includes([139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-COMBO');
						   }

						   if(_.includes([119,121,122,123,124,125,126,127],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','PREG');
						   }
						   if(_.includes([128,129,130,131,132,133,134],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','INSEM');
						   }
							if(_.includes([135,136,137,138,139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','CONCEP');
							}
					} 
					  //DISEASE
					  if(_.includes([6,17,28,120,149,151,153,155,157,159,163,165,167,173,175,176],_.get(question,'QuestionId'))){
						_.set(question,'Category','DISEASE');
						if(_.includes([119],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MGMT');
						   }
						   if(_.includes([6],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD');
						   }
						   if(_.includes([17],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-RP');
						   }
						   if(_.includes([28],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-K');
						   }
						   if(_.includes([120],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MF');
						   }
						   if(_.includes([149],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MET');
						   }
						   if(_.includes([151],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-DA');
						   }
						   if(_.includes([153],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MAST');
						   }
						   if(_.includes([155],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','DYSTOCIA');
						   }
						   if(_.includes([157],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PNEUMONIA');
						   }
						   if(_.includes([159],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','LAMENESS');
						   }
						   if(_.includes([163],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TWIN');
						   }
						   if(_.includes([165],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','STILLBIRTH');
						   }
						   if(_.includes([167,173],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CULL');
						   }
						   if(_.includes([175,176],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						   }

						   // subtitle

						   if(_.includes([6,17,28,120,149,151,153,155,157,159,163,165,167,173,175,176],_.get(question,'QuestionId'))){
						    	_.set(question,'Subtitle','MGMT');
						   }
						  
					} 
					  //PERS
					  if(_.includes([63,64,65],_.get(question,'QuestionId'))){
						_.set(question,'Category','PERSON');

						   if(_.includes([63,64],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TRAIN');
							_.set(question,'Subtitle','TRAIN');
						   }

						   if(_.includes([65],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //CALC
					  if(_.includes([4,8,15,19,26,30,37,39],_.get(question,'QuestionId'))){
						_.set(question,'Category','CALCULA');
						if(_.includes([4,8,15],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','FACILITY');
						   }

						   if(_.includes([19,26,30,37,39],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						   }

						   // subtitles
						   if(_.includes([4,8,15,19,26,30,37,39],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //INFO
					  if(_.includes([3,5,11],_.get(question,'QuestionId'))){
						_.set(question,'Category','INFORM');
						if(_.includes([3,5,11],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //PEN
                      if(_.includes([12,14,15],_.get(question,'QuestionId'))){
						_.set(question,'Category','PEN');
						if(_.includes([12,14,15],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PEN');
							_.set(question,'Subtitle','PEN');
						   }
					} 
				 
					  var answer = _.get(question,'Answer');
					  if(!_.isUndefined(answer)){
						  if(_.isUndefined(answer,'IsOptedOut')){
							_.set(question,'Answer.IsOptedOut',false);
						  }
					   
					  }
				});

			};
			 
		   //------------------

			$s.checkPermissions = function checkPermissions(callback){
				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
					var currentAudit = _.find(data,{AuditId: self.auditId},'Name');

					var checkedOutToPersonId = _.get(MSF.parseJsonStringToObject(_.get(currentAudit,'CheckedOutTo','{}'),"Failed to parse CheckedOutTo in checkPermissions on Review Draft."), 'PersonId');
					 // if checkedOutToPersonId is undefined then the audit is not checked out and we need to redirect the user to the top level f360 report
					 // Similarly if the audit is checked out to a different user than the current logged in one, we need to redirect the user to the top level f360 report
					if(_.isUndefined(checkedOutToPersonId) || (!_.isEqual(checkedOutToPersonId,_.get(cookies.user,'PersonId')))){
						MSF.loadPage('Fertility360report');
					}

					callback();

				});
			};

		
            function formatDate(date){
				var formattedDate = null;
				if(!_.isNull(date)){					
					formattedDate = moment(date).toDate();
				}
				
				 
				return formattedDate;
			}
			$s.formatDateString = function(dateTimeString){
					
                 var stringDate = null;
				 if(!_.isNull(dateTimeString)){
					 var dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
					 stringDate = moment(dateTimeString).format(dateFormat);
				}
				return stringDate;
			}
			function formatDateTimeString(date){
					
				var stringDate = null;
				if(!_.isNull(date)){
					stringDate = moment(date).subtract(moment(date).utcOffset(), 'minutes').utc().format();
			   }
			   return stringDate;
		   }
			function getDaysInMonth(year, month) {
			   return new Date(year, month, 0).getDate();	
			}
			function getMaxNextEvaluationDate(input,months){
				const date = new Date(input);
				date.setDate(1);
				date.setMonth(date.getMonth() + months);
				date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)));
				return moment(date);
			}
			function buildReportData(){

       

				
			   
				// resultsWriteRptJson data 

				// in the database next evaluation date is stored as a string, the date input control requires a date
				_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get($s.reportData,'resultsWriteRptJson.formattedHighlights',""));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',""));
				
				var resultsWriteRptData = _.get($s.reportData,'resultsWriteRptJson');
				if(!_.isUndefined(resultsWriteRptData)){
					_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get(resultsWriteRptData,'formattedHighlights',""));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get(resultsWriteRptData,'nextEvaluationDate',""));
	
					_.forEach($s.report.resultsWriteRptJson.comments,function(comment,index){
						_.set(comment,'formattedComments',_.get(_.find(_.get(resultsWriteRptData,'comments'),{category: _.get(comment,'category')}),'formattedComments',""));
					});
				}
	

				     setAuthorsDisplay();
				

					_.set($s.report,'reviewDraftRptJson.reportDate',$s.reportDate);
					_.set($s.report,'reviewDraftRptJson.milkingCnt', _.get($s.reportData,'reviewDraftRptJson.milkingCnt'), "");
					_.set($s.report,'reviewDraftRptJson.pregRate',getRateValueByQuestionId($s.pregRateQuestionId));		
					_.set($s.report,'reviewDraftRptJson.concRate',getRateValueByQuestionId($s.concRateQuestionId));
					if(_.isUndefined(_.get($s.report,'reviewDraftRptJson.reviewedReport'))){
						_.set($s.report,'reviewDraftRptJson.reviewedReport',false);
					}
					// action item groups and items
					_.set($s.report,'reviewDraftRptJson.actionItemGroups',_.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]));
				    $s.actionItemGroups =  _.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]);

					_.forEach($s.actionItemGroups,function(actionItemGroup){
						_.set(actionItemGroup,'AssociatedMetricsDisplay',

							$s.getAssociatedMetricsStringList(_.get(actionItemGroup,'AssociatedMetrics',[]),"Metric",",")
					     );
					});

					// farm admin list

					$s.people = _.map( _.filter(_.get(MSF,'lists.personActiveFarmAdmins',[]),{farmId: _.get($s.activeFarm,'farmId')}), function(farmAdmin){
                                        return {
											      FarmId: 	    _.get(farmAdmin,'farmId'),
											      PersonId: 	_.get(farmAdmin,'personId'),
											      FirstName: 	_.get(farmAdmin,'firstName'),
										     	  LastName: 	_.get(farmAdmin,'lastName'),
										    	  FullName: 	_.get(farmAdmin,'fullName')

										  };
					            });

					

			}
			$s.getAssociatedMetricsStringList = function getAssociatedMetricsStringList(metricsArray,fieldName,seperator){
                    var stringList = "";
					if(_.get(metricsArray,'length') > 0){

						var fieldCodes = _.pluck(metricsArray,fieldName);
						var dispalyValues = _.map( fieldCodes,function(metricCode){
													var displayMetricName = metricCode;
															var metricCodeValue = _.get(_.find($s.codeFile,{codeType: "ACTIONITEMMETRIC",code:metricCode}),'codeValue');
															if(!_.isUndefined(metricCodeValue)){
																displayMetricName = metricCodeValue;
															}
															return displayMetricName;
												});
						if(_.get(dispalyValues,'length') > 0){
							stringList = dispalyValues.join(seperator);
						}
						
					}
				
				return stringList;
			};
			function loadCurrentHerd(callback){
				   
				auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }
						$s.currentHerd =  herd[0];
						var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
								   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
					
						  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
							 MSF.loadPage('Login');
						  }
			  
					  callback();       
				});

			 
		  }
			function setAuthorsDisplay(){

				auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
					var currentAudit = _.find(data,{AuditId: self.auditId},'Name');
                    var authors = MSF.parseJsonStringToArray(_.get(currentAudit,'Authors','{}'),"Failed to parse Authors in setAuthorsDisplay on Review Draft.")
					var authorsDisplay = "";
					if(!_.isUndefined(authors)){
						var authorsFullNames = _.map(authors,(author)=>_.get(author,'FirstName',"") + " " + _.get(author,'LastName',""));
						authorsDisplay = authorsFullNames.join(", ");
					}
					
					$s.authors = authorsDisplay;
					$s.$applyAsync();
				});

			}
			
			function getRateValueByQuestionId(questionId){
				var rateValue = "";
				var answer = _.find($s.auditAnswers,{QuestionId:questionId});

				if(answer){
				   var value = _.get(answer,'AnswerDetailsJson.Value',"");
				   if(!_.isNull(value) && !_.isEqual(value,"")){
					   rateValue = value;
				   } 
				}

                return rateValue;
			} 
			function removeExcludedQuestions(){
				var notApplicableQuestion = _.find($s.auditQuestions, function(question) {
					return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
				  
				  });
			 if(!_.isUndefined(notApplicableQuestion)){
				  var notApplicableQuestionAnswer = _.find($s.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
				  if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue)){
					  //if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
					   var excludedQuestionIds = [];
					   var subHeadingQuestions = _.filter($s.auditQuestions,{SubHeading: notApplicableQuestion.SubHeading});
					   _.forEach(subHeadingQuestions,function(subHeadingQuestion){
						  var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
						  
						  if(!_.isNull(calcTags)){
							  _.forEach(calcTags,function(calcTag){
								 
								  var calcQuestion = _.find($s.auditQuestions,function(question){ 
													  
														  var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
														  if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
																  var valueTagObjects = [];
	
																  _.forEach(calcVarArray,function(calcVarObject){
																	  var calcVarObjectKey = _.keys(calcVarObject)[0];
																	  valueTagObjects.push(calcVarObject[calcVarObjectKey]);
																	  
																  });
																  var calcQuestionMatch = false;
																  _.forEach(valueTagObjects,function(valueTagObject){
																	  if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																		  calcQuestionMatch = true;
																		  return false;		
																	  }
	
																  });
	
	
																  return calcQuestionMatch;
														  }
													   
														  
													  });
									 if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
										 excludedQuestionIds.push(calcQuestion.QuestionId);
									 }	
							  });
						  }
						  
					   });
	
					  
					  // then  we want to exclude the questions in that subheading for the counts on the overview screen
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.SubHeading,notApplicableQuestion.SubHeading) || _.includes(excludedQuestionIds,question.QuestionId);});
	
					 
					 
				  }else{
					  //even if the not applicable question is false, we still don't want to include it in the answer count
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.QuestionId,notApplicableQuestion.QuestionId);});
				  }	   
			 }
			}
			function buildStructuredQuestionsAndAnswers(){
				
				
				_.forEach($s.codeFileQuestionCategories,function(codeFileQuestionCategory){
					var categoryCode = _.get(codeFileQuestionCategory,'code');
					var structuredQuestionsAndAnswersItem = {
						categoryCode: categoryCode,
						categoryDisplay: _.get(codeFileQuestionCategory,'codeValue'),
						categoryOrder: _.get(_.find($s.codeFileQuestionOrders,{code: categoryCode}),'dropDownSeq'),
						showInPieChart: _.get(codeFileQuestionCategory,'detailsJson[0].showInPieChart')
					};
	
					
					var subCategoriesOfCategory = _.filter($s.codeFileQuestionSubCategories,{categoryCode: categoryCode});
					
					// subcategories 
					var structuredSubCategories = [] ;
					_.forEach(subCategoriesOfCategory,function(codeFileSubCategory){
						var categoryCode = _.get(codeFileSubCategory,'categoryCode');
	
						_.forEach(_.get(codeFileSubCategory,'subCategories'),function(subCategory){
	
						
							var structuredSubCategory = {
								categoryCode: categoryCode,
								subCategoryKey: _.get(subCategory,'key'),
								subCategoryKeyDisplay: _.get(subCategory,'description'),
								subCategoryOrder: _.get(subCategory,'Order'),
								metGuidelineQuestions: [],
								outsideGuidelineQuestions: []
	
							};
	
							   var subCategoryQuestions = _.filter($s.auditQuestionsWithAnswers,{Category: categoryCode ,SubCategory: _.get(subCategory,'key')});
							   var subCateogryMetGuidelineQuestions = _.filter(subCategoryQuestions,function(question){
																		   var metGuideLines = _.get(question,'Answer.MetGuideline');
																		   if(!_.isUndefined(metGuideLines)){
																			   if(metGuideLines){
																				   return question;
																			   }
																		   }
																	  });
							   var subCateogryOutsideGuidelineQuestions =  _.filter(subCategoryQuestions,function(question){
																					var metGuideLines = _.get(question,'Answer.MetGuideline');
																					if(!_.isUndefined(metGuideLines)){
																						if(!metGuideLines){
																							return question;
																						}
																					}
																			});
							  _.set(structuredSubCategory,'metGuidelineQuestions',subCateogryMetGuidelineQuestions);
							  _.set(structuredSubCategory,'outsideGuidelineQuestions',subCateogryOutsideGuidelineQuestions);												
	
							
							structuredSubCategories.push(structuredSubCategory);
						});
						
					});	
	
					 structuredSubCategories = _.sortByOrder(structuredSubCategories,["subCategoryOrder"],["asc"]); 
					_.set(structuredQuestionsAndAnswersItem,'subCategories',structuredSubCategories);
					   
	
	
					// subtitles
					var codeFileSubtitlesOfCategory = _.filter($s.codeFileQuestionSubtitles,{orderCode: categoryCode});
	
					var structuredSubTitles = [] ;
					_.forEach(codeFileSubtitlesOfCategory,function(codeFileSubtitle){
						var categoryCode = _.get(codeFileSubtitle,'orderCode');
	
						_.forEach(_.get(codeFileSubtitle,'subtitles'),function(subtitle){
	
						
							var structuredSubtitle = {
								categoryCode: categoryCode,
								subtitleKey: _.get(subtitle,'key'),
								subtitleKeyDisplay: _.get(subtitle,'description'),
								subtitleOrder: _.get(subtitle,'Order'),
								metGuidelineQuestions: [],
								outsideGuidelineQuestions: []
							};
							//,SubCategory: categoryCode
							var subtitleQuestions = _.filter($s.auditQuestionsWithAnswers,{Category: categoryCode ,Subtitle: _.get(subtitle,'key')});
							var subtitleMetGuidelineQuestions = _.filter(subtitleQuestions,function(question){
																		var metGuideLines = _.get(question,'Answer.MetGuideline');
																		if(!_.isUndefined(metGuideLines)){
																			if(metGuideLines){
																				return question;
																			}
																		}
																   });
							var subtitleOutsideGuidelineQuestions =  _.filter(subtitleQuestions,function(question){
																				 var metGuideLines = _.get(question,'Answer.MetGuideline');
																				 if(!_.isUndefined(metGuideLines)){
																					 if(!metGuideLines){
																						 return question;
																					 }
																				 }
																		 });
						   _.set(structuredSubtitle,'metGuidelineQuestions',subtitleMetGuidelineQuestions);
						   _.set(structuredSubtitle,'outsideGuidelineQuestions',subtitleOutsideGuidelineQuestions);	
	
						   $s.allMetGuidelineQuestions = _.union( $s.allMetGuidelineQuestions,subtitleMetGuidelineQuestions);
						   $s.allOutsideGuidelineQuestions = _.union( $s.allOutsideGuidelineQuestions,subtitleOutsideGuidelineQuestions);
							
							structuredSubTitles.push(structuredSubtitle);
						});
						
					});	
					structuredSubTitles = _.sortByOrder(structuredSubTitles,["subtitleOrder"],["asc"]); 
					_.set(structuredQuestionsAndAnswersItem,'subtitles',structuredSubTitles);
	
					$s.structuredQuestionsAndAnswers.push(structuredQuestionsAndAnswersItem);
	
			  });
	
			  $s.structuredQuestionsAndAnswers = _.sortByOrder($s.structuredQuestionsAndAnswers,["categoryOrder"],["asc"]);
	
			  $s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
			  $s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
			  $s.orderedQuestionsAndAnswers = _.union($s.allOutsideGuidelineQuestions,$s.allMetGuidelineQuestions);
			
			}

			function loadPieCharts(){
				//all data for pie charts are for questions that have an industry guideline
				
				// overall summary pie chart 
				_.set($s.overallSummaryPieChart,'title',"Questions that Met Industry Guideline");
				
		
				var overallSummaryQuestionData = [
					{name: "Met Guideline", data: _.filter($s.allMetGuidelineQuestionsWithGuidelines,function(question){ return !_.isEqual(_.get(question,'Category'),"INFORM");}).length},
					{name: "Did Not Meet Guideline", data: _.filter($s.allOutsideGuidelineQuestionsWithGuidelines,function(question){return _.isEqual(_.get(question,'Answer.IsOptedOut'),false) &&  !_.isEqual(_.get(question,'Category'),"INFORM");}).length},
					{name: "Not Answered", data: _.filter($s.allOutsideGuidelineQuestionsWithGuidelines,function(question){return _.isEqual(_.get(question,'Answer.IsOptedOut'),true) &&  !_.isEqual(_.get(question,'Category'),"INFORM")}).length}
				];
				_.set($s.overallSummaryPieChart,'seriesData',overallSummaryQuestionData);

				var overallPieChartCanvasElement = document.getElementById("overallSummaryPieChart");// $('#overallSummaryPieChart')[0];
				var overallPieChartElement = overallPieChartCanvasElement.getContext('2d');
				
				var overallPieChartOptions = {
					title:{
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
			$s.overallSummaryPieChart.chart = ChartService.getCircleChart(overallPieChartElement, overallPieChartOptions,$s.overallSummaryPieChart.seriesData, $s.overallSummaryPieChart.title);

			
						
			}

			function loadBarCharts(){
						  
			   // Question Category Chart

			   _.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline by Category"]);
			 


			   var metGuidelineQuestionsSeriesDataByCategory = [];
			   var outsideGuidelineQuestionsSeriesDataByCategory = [];
			   var optedQuestionsSeriesDataByCategory = [];

			   var allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) && !_.isEqual(_.get(question,'Category'),"INFORM");});
			   var allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) && !_.isEqual(_.get(question,'Category'),"INFORM");});         
		 
			 
			   var filteredCodeFileQuestionCategories = _.filter($s.codeFileQuestionCategories,function(category){return !_.isEqual(_.get(category,'code'),"INFORM"); } );
			   _.forEach(filteredCodeFileQuestionCategories,function(codeFileCategory){
					 
				var metGuidelineQuestionsByCategory = _.filter(allMetGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code')});
				metGuidelineQuestionsSeriesDataByCategory.push(metGuidelineQuestionsByCategory.length);

				var outsideGuidelineQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code'),Answer : {IsOptedOut: false}});
				outsideGuidelineQuestionsSeriesDataByCategory.push(outsideGuidelineQuestionsByCategory.length);

				var optedQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code'),Answer : {IsOptedOut: true}});
				optedQuestionsSeriesDataByCategory.push(optedQuestionsByCategory.length);
					 
			 });

			 var categoryBarChartData = {
				categoryLabels: _.map(filteredCodeFileQuestionCategories,function(codeFileCategory){ return _.get(codeFileCategory,'codeValue');}),
			  seriesData : []

			 };
			   
				 
			   categoryBarChartData.seriesData.push( {
				label: "Met Guideline",
				data: metGuidelineQuestionsSeriesDataByCategory,
				backgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderWidth: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
				hoverBackgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
				hoverBorderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
		   },{
			   label: "Did Not Meet Guideline",
			   data: outsideGuidelineQuestionsSeriesDataByCategory,
			   backgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderWidth: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
			   hoverBackgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
			   hoverBorderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
		   },{
			label: "Not Answered",
			data: optedQuestionsSeriesDataByCategory,
			backgroundColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#ededed")),
			borderColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#ededed")),
			borderWidth: _.times(optedQuestionsSeriesDataByCategory.length,_.constant(1)),
			hoverBackgroundColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#d9d9d9")),
			hoverBorderColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#d9d9d9")),
		});

		   _.set($s.categoryBarChart,'seriesData',categoryBarChartData);

		  var categoryStepSize = 5;

		   var categoryBarChartOptions = {
			   title: {
				   display: true,
				   fontSize: 14
			   },
			   legend:{
				   labels:{
					   boxWidth: 15
				   },
				   position: "bottom"
				   
			   },
			   scales: {
				xAxes: [{
				   stacked: false,
				   categoryPercentage: 1.0,
				   barPercentage: 0.75,
				   ticks: {
					   autoSkip: false,
					   suggestedMax: 40
				   }
					}]
			  },
			   tooltips:{
				   enabled: false
			   }
		   };

		  var categoryBarChartCanvasElement = document.getElementById("categoryBarChart");
		  var categoryBarChartElement = categoryBarChartCanvasElement.getContext('2d');
		  $s.categoryBarChart.chart  =  ChartService.getBarChart(categoryBarChartElement,categoryBarChartOptions, $s.categoryBarChart.seriesData, $s.categoryBarChart.title, categoryStepSize);
		

			}
	
			// function that loads the followup items on load of the results and write report screen
			function loadFollowupItems(){
				
				var allQuestions = _.flattenDeep(
					_.map( _.pluck($s.structuredQuestionsAndAnswers,'subtitles'),function(subtitlesOfCategory){
						  var questions =  _.union(_.flattenDeep(_.pluck(subtitlesOfCategory,'metGuidelineQuestions')),_.flattenDeep(_.pluck(subtitlesOfCategory,'outsideGuidelineQuestions')));
						  return questions;
					})
				);

                $s.followupItems = _.filter(allQuestions,{Answer: {FollowUp: true}});
				
			}
			function getMilkingCount(){
				var milkingCnt = "";

				var currentHerd = MSF.getActiveHerd();

				if (!_.isEmpty(currentHerd)) {
					api.getReportDetailsByReportCodeAndHerdId({
						reportCode: 'DASHBOARDCLASSIC',
						herdId: currentHerd.herdId
					}, function reportDetailsGotten(err, reportData) {

                        var breakpoint = "";
					});

				}
				return milkingCnt;
			}
			$s.updateAnswers = function updateAnswers(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;	
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress = true;
						log.info("Review Draft answerUpdate: start");
		
						var AnswerJson = JSON.stringify($s.auditAnswers);
						$s.isDirty = true;
						auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error getting F360 online check: ' + err);
								$s.isDirty = false;
								
							$s.updateInProgress = false;
							$s.syncInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 940");
								$s.finalSaveRequired = false;
								$s.updateAnswers();
							}
							log.info("Review Draft answerUpdate: update of answer failed, update end");
								
							}else{		
								
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){

						
								
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});

									log.info("Review Draft answerUpdate: updating last synced date with : ");
									log.info(auditlistItem);

									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 940");
												$s.finalSaveRequired = false;
												$s.updateAnswers();
											}
											log.info("Review Draft answerUpdate: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("Review Draft answerUpdate: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 940");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
										}
									}

								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 940");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
										}
										log.info("Review Draft answerUpdate: offline and updated is dirty flag, update end");
								});
							}
								
							//console.log('update ok');
							}
							

						
							
						});
					});
				}else{
					log.info("an answer save attempt was made while another one was going");
					$s.finalSaveRequired = true;
					
				 }
			};

			//function that constructs the display value of a given text value  
			$s.getTextDisplayValue  = function getTextDisplayValue(text){

				// replace any measurement standard text 
				var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

				text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

				return text;

			};
			// function that formats a questions answer value and returns the formatted value
			$s.formatAnswer = function(question){
			
				var formattedAnswerValue = "";
	
				var questionTemplate = _.get(question,'QuestionTemplate',"");
				var answerValue = _.get(question,'Answer.Value',"");
				var codeType = _.get(question,'CodeType',"");
	
				switch(questionTemplate){
					case "%3,0":
					case "%5,1":
						if(_.isEqual(_.get(question,'Answer.IsOptedOut'),false)){
							formattedAnswerValue = answerValue + '%';
						}else{
							formattedAnswerValue = answerValue;
						}
					break;
					case "SINGL":
						formattedAnswerValue = _.get(_.find($s.codeFile,{codeType: codeType,code: answerValue}),'codeValue',answerValue); 
					break;
					case "YN":
					   if(answerValue === "Y"){
						   formattedAnswerValue = "Yes";
					   }else if(answerValue === "N"){
						   formattedAnswerValue = "No";
					   } 
					break;
					case "MULTI":
						var valueList = answerValue;
						valueList = valueList.replace(/["()']/g,""); 
						//then we create an array to compare value to 							
						var values = valueList;
						values = valueList.split(',');
						// if the code type for the question was MONTH we need to order the values by calendar order
						if(_.isEqual(question.CodeType,"MONTH")){
						
						 var months = _.filter($s.codeFile,{codeType:"MONTH"});
		
						 values = _.sortBy(values, x => _.findIndex(months, y => _.isEqual(x,y.code))); 
						}
	
						// the values we want to dispaly in the grid is the codeValue(s)(button label) of the code(s)(answer choice) chosen. 
						values = _.map(values,function(value){
							return _.get(_.find($s.codeFile,{code: value}),'codeValue',value); 
						});
						values = values.join(', ');
	
	
						formattedAnswerValue = values;
		
					break;
					default:
					  formattedAnswerValue = answerValue;
	
				}
				return formattedAnswerValue;
			};
			$s.formatIndustryGuideline = function(guideline){
	  
				 var formattedGuideline = "";
				switch(guideline){
					case "---":
					case undefined:{
						formattedGuideline = "N/A";
					break;
					}
					default:
						formattedGuideline = guideline;
					break;	
				}
				return formattedGuideline;
			};

			function formatNextEvaluationDateForServer(date){
			
				var formattedDate = date;
				   
				
				formattedDate = moment(date).format('M/D/YYYY');
			
				return formattedDate;
			}

			$s.updateResultsAndDraft = function updateResultsAndDraft(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress = true;
						log.info("updateResultsAndDraft: start");
						// The next evaluation date should be stored in json field with the pattern "MM/DD/YYYY" , but the NextEvaluationDate field requires a date.
						var reportData = angular.copy($s.report);
						var nextEvaluationDateObject = reportData.resultsWriteRptJson.nextEvaluationDate;
						reportData.resultsWriteRptJson.nextEvaluationDate = formatNextEvaluationDateForServer(reportData.resultsWriteRptJson.nextEvaluationDate);
	
                         var actionItemGroups = _.cloneDeep($s.actionItemGroups);
					
	
						 _.forEach(actionItemGroups,function(actionItemGroup,index,array){
						
							array[index] = _.omit(actionItemGroup,['AssociatedMetricsDisplay','$$hashKey']);

							 _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,index,array){
								  array[index] = _.omit(actionItem,'$$hashKey');
							 });
						 }); 
	
						_.set(reportData,'reviewDraftRptJson.actionItemGroups',actionItemGroups);


						var draftNotesJson = JSON.stringify(reportData);
						$s.isDirty = true;
						auditService.updateReviewResults(auditId,draftNotesJson,nextEvaluationDateObject,function(data){
						var error = _.get(data,'Error');
						if(error){
							log.error(error);
							$s.isDirty = false;
							$s.updateInProgress = false;
							$s.syncInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 1052");
								$s.finalSaveRequired = false;
								$s.updateResultsAndDraft();
							}
							log.info("updateResultsAndDraft: update failed, update end");
						}else{
	
						
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){
	
											
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});
	
									log.info("updateResultsAndDraft: updating last synced date with : ");
									log.info(auditlistItem);
	
									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 1086");
												$s.finalSaveRequired = false;
												$s.updateResultsAndDraft();
											}
											log.info("updateResultsAndDraft: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("updateResultsAndDraft: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 1097");
											$s.finalSaveRequired = false;
											$s.updateResultsAndDraft();
										}
										
									}
	
								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									$s.updateInProgress = false;
									$s.syncInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 1114");
										$s.finalSaveRequired = false;
										$s.updateResultsAndDraft();
									}
									log.info("updateResultsAndDraft: offline and updated IsDirty flag, update end");
								});
							}
						
						}     
	
						});
					});
				}else{
				   log.info("an answer save attempt was made while another one was going");
				   $s.finalSaveRequired = true;
				   
				}
			}; 

			$s.onAddActionItemGroup = function onAddActionItemGroup(){
				//console.log("add Profit Driver");

				$s.currentActionItemGroup = _.cloneDeep($s.actionItemGroupTmpl);

				_.set($s.currentActionItemGroup,'HerdId',_.get($s.currentHerd,'herdId'));
				_.set($s.currentActionItemGroup,'AuditId',self.auditId);

				$s.isEditingActionItemGroup = false;
				$s.toggleModal("actionItemGroupModal");
			};

			$s.onEditActionItemGroup = function onEditActionItemGroup(actionItemGroup){
				//console.log("Edit Profit Driver");
                //console.log(actionItemGroup);
                $s.currentActionItemGroupRef = actionItemGroup;

				$s.currentActionItemGroup = _.cloneDeep(actionItemGroup);


				if(_.isEqual(_.get(actionItemGroup,'ActionItemGroupKey'),"OTHER")){
					_.set($s.currentActionItemGroup,'ActionItemGroupKeyFreeText',_.get(actionItemGroup,'Description'));
				}

               
                $s.isEditingActionItemGroup = true;

					 _.set($s.currentActionItemGroup,'AssociatedMetrics',_.map(_.get($s.currentActionItemGroup,'AssociatedMetrics'),function(metric){
																			return _.get(metric,'Metric');
																		})
                     );


                $s.toggleModal("actionItemGroupModal");
			};

			$s.onEditActionItem = function onEditActionItem(actionItem,actionItemGroup){
		
				$s.isEditingActionItem = true;
				$s.currentActionItem = _.cloneDeep(actionItem);
             
				_.set($s.currentActionItem,'Person',{
													  FarmId: 	    _.get($s.currentActionItem,'FarmId'),
					 								  PersonId: 	_.get($s.currentActionItem,'PersonId'),
													  FirstName: 	_.get($s.currentActionItem,'FirstName'),
													  LastName: 	_.get($s.currentActionItem,'LastName'),
													  FullName: 	_.get($s.currentActionItem,'FullName')

													});

                 _.set($s.currentActionItem,'DueDate', moment(_.get($s.currentActionItem,'DueDate')).toDate());													



				$s.currentActionItemRef = actionItem;
				$s.currentActionItemGroupRef = actionItemGroup;
				$s.toggleModal("actionItemModal");
			};

			$s.onAddActionItem = function onAddActionItem(actionItemGroup) {
				//console.log(actionItemGroup);

				$s.currentActionItem = _.cloneDeep($s.actionItemTmpl);
				_.set($s.currentActionItem,'Status',"NS");
				_.set($s.currentActionItem,'AuditId',self.auditId);

				$s.currentActionItemGroupRef = actionItemGroup;
				$s.isEditingActionItem = false;

				//console.log("Add Action Item to "+_.get(actionItemGroup,'ActionItemGroupKey'));
				
				$s.toggleModal("actionItemModal");
			};


			$s.onSave = function onSave(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":
						var validationErrors = $s.validateActionItemGroup($s.currentActionItemGroup);
						if(_.isEmpty(validationErrors)){
                              

							if(_.isEqual(_.get($s.currentActionItemGroup,'ActionItemGroupKey'),"OTHER")){
								_.set($s.currentActionItemGroup,'Description',_.get($s.currentActionItemGroup,'ActionItemGroupKeyFreeText'));
							}else{
								_.set($s.currentActionItemGroup,'Description',_.get(_.find($s.codeFileActionItemGroups,{code: _.get($s.currentActionItemGroup,'ActionItemGroupKey')} ),'codeValue'));
							}
							$s.currentActionItemGroup = _.omit($s.currentActionItemGroup,'ActionItemGroupKeyFreeText');  
					        
							if(_.get(_.get($s.currentActionItemGroup,'AssociatedMetrics'),'length') > 0){
								_.set($s.currentActionItemGroup,'AssociatedMetrics',_.map(_.get($s.currentActionItemGroup,'AssociatedMetrics'),function(metricCode){
																						return {Metric: metricCode};
																					})

                                );
							}
							_.set($s.currentActionItemGroup,'AssociatedMetricsDisplay', $s.getAssociatedMetricsStringList(_.get($s.currentActionItemGroup,'AssociatedMetrics',[]),"Metric",","));
							
							
							
							if ($s.isEditingActionItemGroup) {

								// update existing group 

								_.forEach($s.actionItemGroups,function(actionItemGroup,index,array){
									if(_.isEqual(_.get(actionItemGroup,'$$hashKey'),_.get($s.currentActionItemGroupRef,'$$hashKey'))){

										array[index] = _.cloneDeep($s.currentActionItemGroup);
									}
								});						

							} else {
								$s.actionItemGroups.push($s.currentActionItemGroup);
							}

							$s.isEditingActionItemGroup = false;
							$s.currentActionItemGroup = {};
							$s.currentActionItemGroupRef = {};
							$s.toggleModal(modalId);
							$s.clearAllActionItemGroupValidationErrors();
							$s.updateResultsAndDraft();
						}else{
							_.forEach(validationErrors,function(error){
								var controlId = _.get(error,'controlId');
								var controlErrorTextId = _.get(error,'controlErrorTextId');
								$(controlId).addClass('error'); 
								$(controlErrorTextId).removeClass('dis-none');       
							});
						}
						break;
					case "ACTION_ITEM":

						var validationErrors = $s.validateActionItem($s.currentActionItem,$s.currentActionItemGroupRef);
						if(_.isEmpty(validationErrors)){

							// flatten Person object and remove the property
                            _.set($s.currentActionItem,'PersonId',_.get($s.currentActionItem,'Person.PersonId'));
							_.set($s.currentActionItem,'FirstName',_.get($s.currentActionItem,'Person.FirstName'));
							_.set($s.currentActionItem,'LastName',_.get($s.currentActionItem,'Person.LastName'));
							_.set($s.currentActionItem,'FullName',_.get($s.currentActionItem,'Person.FullName'));

							$s.currentActionItem = _.omit($s.currentActionItem,'Person');

							_.set($s.currentActionItem,'DueDate', moment(_.get($s.currentActionItem,'DueDate')).format('M/D/YYYY'));


							if ($s.isEditingActionItem) {

								// update existing item 
	
								_.forEach(_.get($s.currentActionItemGroupRef,'ActionItems',[]),function(actionItem,index,array){
									   if(_.isEqual(_.get(actionItem,'$$hashKey'),_.get($s.currentActionItemRef,'$$hashKey'))){
	
										   array[index] = _.cloneDeep($s.currentActionItem);
									   }
								});
		
							} else {
								_.get($s.currentActionItemGroupRef,'ActionItems',[]).push($s.currentActionItem);
							}
	
								
							$s.isEditingActionItem = false;
							$s.currentActionItem = {};
							$s.currentActionItemRef = {};
							$s.currentActionItemGroupRef = {};
							$s.toggleModal(modalId);
							$s.clearAllActionItemValidationErrors();
							$s.updateResultsAndDraft();
						}else{
							_.forEach(validationErrors,function(error){
								var controlId = _.get(error,'controlId');
								var controlErrorTextId = _.get(error,'controlErrorTextId');
								$(controlId).addClass('error'); 
								$(controlErrorTextId).removeClass('dis-none');       
							});
						}
						break;
					default:
						break;
				}
				
			};

			$s.onCancel = function onCancel(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":
						$s.isEditingActionItemGroup = false;
						$s.currentActionItemGroup = {};
						$s.currentActionItemGroupRef = {};
						$s.clearAllActionItemGroupValidationErrors();
						break;
					case "ACTION_ITEM":
						$s.isEditingActionItem = false;
						$s.currentActionItem = {};
						$s.currentActionItemRef = {};
						$s.currentActionItemGroupRef = {};
						$s.clearAllActionItemValidationErrors();
						break;
					default:
						break;
				}
				$s.toggleModal(modalId);
			};

			$s.onDelete = function onDelete(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":

						MSF.confirm({
							title: 'Remove',
							messageHeader: "Profit Driver: "+_.get($s.currentActionItemGroup,'Description',""),
							message: "Are you sure you want to remove this Profit Driver? Removing the Profit Driver will remove all Action Items under it.",
							confirm: {
								className: 'danger',
								icon: 'trash',
								text: "Remove"
							}
					  }, function confirmActionItemGroupRemoval(){
					  
						$s.$applyAsync($s.actionItemGroups = _.reject($s.actionItemGroups,$s.currentActionItemGroupRef));	
						
						$s.isEditingActionItemGroup = false;
						$s.currentActionItemGroup = {};
						$s.currentActionItemGroupRef = {};

						$s.toggleModal(modalId);
						$s.updateResultsAndDraft();
	  
					  },function cancelActionItemGroupRemoval(){
						  
						   log.info("The ActionItemGroup removal was canceled");
					  });
					  
						break;
					case "ACTION_ITEM":

					
						var existingActionItem = _.find(_.get($s.currentActionItemGroupRef,'ActionItems',[]),{Description: _.get($s.currentActionItemRef,'Description')});
					
						MSF.confirm({
							title: 'Remove',
							messageHeader: "Action Item: "+_.get(existingActionItem,"Description",""),
							message: "Are you sure you want to remove this Action Item?",
							confirm: {
								className: 'danger',
								icon: 'trash',
								text: "Remove"
							}
					  }, function confirmActionItemRemoval(){
					  
						var actionItemGroupActionItems = _.get($s.currentActionItemGroupRef,'ActionItems',[]);

						_.forEach($s.actionItemGroups,function(actionItemGroup){
                             if(_.isEqual(_.get(actionItemGroup,'Description'),_.get($s.currentActionItemGroupRef,'Description'))){
								$s.$applyAsync(actionItemGroup.ActionItems = _.reject(actionItemGroup.ActionItems,$s.currentActionItemRef));
							 }
						});

						
						$s.isEditingActionItem = false;
						$s.currentActionItem = {};
						$s.currentActionItemRef = {};
						$s.currentActionItemGroupRef = {};

						$s.toggleModal(modalId);
						$s.updateResultsAndDraft();
	  
					  },function cancelActionItemRemoval(){
						  
						   log.info("The ActionItem removal was canceled");
					  });
					
						break;
					default:
						break;
				}
				
			};
			$s.clearAllActionItemGroupValidationErrors = function clearAllActionItemGroupValidationErrors(){
				$("#modalActionItemGroupKey").removeClass('error');
				$("#errorInputActionItemGroupKey").addClass('dis-none');

				$("#modalActionItemGroupKeyFreeText").removeClass('error');
				$("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
				
				$("#modalActionItemGroupAssociatedMetric").removeClass('error');
				$("#errorInputAssociatedMetricText").addClass('dis-none');

				$s.actionItemGroupKeyErrorText = "";
				$s.actionItemGroupKeyFreeTextErrorText = "";
				
				
			};

			$s.clearAllActionItemValidationErrors = function clearAllActionItemValidationErrors(){
				$("#modalActionItemDescription").removeClass('error');
				$("#errorInputDescriptionText").addClass('dis-none');

				$("#modalActionItemAssignedTo").removeClass('error');
				$("#errorInputAssignedToText").addClass('dis-none');
				
				$("#modalActionItemDueDate").removeClass('error');
				$("#errorInputDueDateText").addClass('dis-none');

				$s.actionItemGroupKeyErrorText = "";
				$s.actionItemGroupKeyFreeTextErrorText = "";
				
				
			};

			$s.validateActionItem = function validateActionItem(actionItem,actionItemGroup){
				var invalidErrorIds = [];

				
                //--------------------------------------------------------------
				// Description(What To Do) Validation
			    //--------------------------------------------------------------
				var descriptionControlId = "#modalActionItemDescription";
				var descriptionErrorTextId = "#errorInputDescriptionText";
				var description = _.trim(_.get(actionItem,'Description'));
                  
				if(_.isEmpty(description)){
					invalidErrorIds.push({controlId: descriptionControlId,controlErrorTextId: descriptionErrorTextId});
				}
				//--------------------------------------------------------------

				//--------------------------------------------------------------
				// AssignedTo Validation
			    //--------------------------------------------------------------
				 var assignedToControlId = "#modalActionItemAssignedTo";
				 var assignedToErrorTextId = "#errorInputAssignedToText";
				 var assignedTo = _.get(actionItem,'Person',{});

				 if(_.isEmpty(assignedTo)){
					invalidErrorIds.push({controlId: assignedToControlId,controlErrorTextId: assignedToErrorTextId});
				 }
                    
				//--------------------------------------------------------------


				//--------------------------------------------------------------
				// DueDate Validation
			    //--------------------------------------------------------------
				 
				var dueDateControlId = "#modalActionItemDueDate";
				var dueDateErrorTextId = "#errorInputDueDateText";
				var dueDate = _.get(actionItem,'DueDate');

				if(_.isUndefined(dueDate) || _.isEqual(dueDate,"") || moment(dueDate).toDate() <= moment().toDate()){
				   invalidErrorIds.push({controlId: dueDateControlId,controlErrorTextId: dueDateErrorTextId});
				}
				
				//--------------------------------------------------------------

				return invalidErrorIds;
			};

			$s.validateActionItemGroup = function validActionItemGroup(actionItemGroup){
				var invalidErrorIds = [];

				
                //--------------------------------------------------------------
				// Group Key Validation
			    //--------------------------------------------------------------
				var isFreeTextGroupKey = false;
				var groupKeyInputId = "#modalActionItemGroupKey";
				var groupKeyErrorTextId = "#errorInputActionItemGroupKey";
				var chosenGroupKey = _.get(actionItemGroup,'ActionItemGroupKey');
				 
				if(_.isEqual(chosenGroupKey,"OTHER")){
					chosenGroupKey = _.get(actionItemGroup,'ActionItemGroupKeyFreeText');
					groupKeyInputId = "#modalActionItemGroupKeyFreeText";
					groupKeyErrorTextId = "#errorInputActionItemGroupKeyFreeText";
					var isFreeTextGroupKey = true;
				} 
                var refGroupKey = _.get($s.currentActionItemGroupRef,'ActionItemGroupKey');
			
                 // no group key was chosen
                if(_.isEmpty(chosenGroupKey)){
					if(isFreeTextGroupKey){
						$s.actionItemGroupKeyFreeTextErrorText = "Required field.";
					}else{
						$s.actionItemGroupKeyErrorText = "Required field.";
					}
					
					invalidErrorIds.push({controlId: groupKeyInputId,controlErrorTextId: groupKeyErrorTextId});
				}

			    chosenGroupKey = _.trim(chosenGroupKey);

				var existingGroupKeys = _.pluck($s.actionItemGroups,'ActionItemGroupKey');

				   
				if(!_.includes(_.pluck(invalidErrorIds,'controlId'),groupKeyInputId) 
				   && (
					         (!$s.isEditingActionItemGroup && _.includes(existingGroupKeys,chosenGroupKey)) // user is trying to add a new group with a duplicate key
						  || ($s.isEditingActionItemGroup && !_.isEqual(refGroupKey,chosenGroupKey) && _.includes(existingGroupKeys,chosenGroupKey)) // user is editing a group and changed the group key to one that already exists 
					  )
					  
				  ){
					if(isFreeTextGroupKey){
						$s.actionItemGroupKeyFreeTextErrorText = "The profit driver cannot be duplicated.";
					}else{
						$s.actionItemGroupKeyErrorText = "The profit driver cannot be duplicated.";
					}
					invalidErrorIds.push({controlId: groupKeyInputId,controlErrorTextId: groupKeyErrorTextId});
				}
			   //--------------------------------------------------------------

			   //--------------------------------------------------------------
			   // Associated Metrics
			   //--------------------------------------------------------------

                var associatedMetricsControlId = "#modalActionItemGroupAssociatedMetric";
				var associatedMetricsErrorTextId = "#errorInputAssociatedMetricText";

				var associatedMetrics = _.get(actionItemGroup,'AssociatedMetrics',[]);
				if(_.isEqual(_.get(associatedMetrics,'length'),0)){
					invalidErrorIds.push({controlId: associatedMetricsControlId,controlErrorTextId: associatedMetricsErrorTextId});
				}

			   //--------------------------------------------------------------

				return invalidErrorIds;
			};

			


			$s.onActionItemGroupKeyChange = function onActionItemGroupKeyChange() {
                //console.log("test");
                //console.log($s.currentActionItemGroup.actionItemGroupKey);
                var hadError = $("#modalActionItemGroupKey").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupKey").removeClass('error');
					$("#errorInputActionItemGroupKey").addClass('dis-none');
				}

                return true;
            }

			$s.onActionItemGroupKeyFreeTextChange = function onActionItemGroupKeyFreeTextChange(){
				var hadError = $("#modalActionItemGroupKeyFreeText").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupKeyFreeText").removeClass('error');
					$("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
				}
			}
			$s.onActionItemGroupAssociatedMetricsChange = function onActionItemGroupAssociatedMetricsChange(){
				var hadError = $("#modalActionItemGroupAssociatedMetric").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupAssociatedMetric").removeClass('error');
					$("#errorInputAssociatedMetricText").addClass('dis-none');

				}
			}

			$s.onActionItemDescriptionChange = function onActionItemDescriptionChange(){
				var hadError = $("#modalActionItemDescription").hasClass("error");

				if(hadError){
					$("#modalActionItemDescription").removeClass('error');
					$("#errorInputDescriptionText").addClass('dis-none');

				}
			}

			$s.onAssignedToChange = function (val) {
				var hadError = $("#modalActionItemAssignedTo").hasClass("error");

				if(hadError){
					$("#modalActionItemAssignedTo").removeClass('error');
					$("#errorInputAssignedToText").addClass('dis-none');
				}
			}

			
			$s.onDueDateChange = function onDueDateChange() {
				var hadError = $("#modalActionItemDueDate").hasClass("error");

				if(hadError){
					$("#modalActionItemDueDate").removeClass('error');
					$("#errorInputDueDateText").addClass('dis-none');
				}
			}

			$s.toggleModal = function (modalId) {
				var modal = $('#' + modalId);
				if (!modal) return;

				if (modal.is(':visible')) {
					modal.css("display", "none");
				} else {
					modal.css("display", "block");
				}
			}

			$s.toggleField = function toggleField(hideObj, showObj) {
				hideObj.disabled = true;
				hideObj.style.display = 'none';
				showObj.disabled = false;
				showObj.style.display = 'inline';
				showObj.focus();
			}

			$s.onReviewedReportChange = function onReviewedReportChange(){
				$s.checkF360SyncStatus();
			}

			$s.validate = function validate(){
				var validActionItemGroups = true;
				var validActionItems = true;

				if(_.get($s.actionItemGroups,'length') == 0){
					$s.currentTopAnchor = "actionItemGroupSection";
					validActionItemGroups = false;
				}

				var allActionItems = _.pluck($s.actionItemGroups,'ActionItems');
				var anActionItemExists = false;
					anActionItemExists = _.all(allActionItems,function(actionItemArray){
													if(_.get(actionItemArray,'length') > 0){
														return true;
													}
												});
				if(!anActionItemExists){
					$s.currentTopAnchor = "actionItemGroupSection";
					validActionItems = false;
				}


				return validActionItemGroups && validActionItems;
				
			}

			$s.publishActionItemGroups = function publishActionItemGroups(actionItemGroups){

				var actionItemGroupsData = _.cloneDeep(actionItemGroups);
                  
                _.forEach(actionItemGroupsData,function(actionItemGroup,index,groupArray){
                    
                       _.set(actionItemGroup,'HerdId',_.get($s.currentHerd,'herdId'));
					   _.set(actionItemGroup,'AuditId',self.auditId);
					   _.set(actionItemGroup,'GroupDesc',_.get(actionItemGroup,'Description'));
					   _.set(actionItemGroup,'ActionItemJson',_.get(actionItemGroup,'ActionItems'))  
                      
					   actionItemGroup = _.omit(actionItemGroup,["Description","ActionItems"]);

					   groupArray[index] = _.cloneDeep(actionItemGroup);

				});

				api.publishActionItemGroupDetails(self.auditId,JSON.stringify(actionItemGroupsData),function(data){
					   var error = _.get(data,'Error');
					   if(error){
				    	  log.error(error);

					   }
				});



			}

			$s.publishReport = function(){

                if($s.validate()){
				
					 $s.updateInProgress = true;
					 $s.submitting = true;
					log.info("publishReport: start");
					$s.currentTopAnchor = "";
					
					var reportData = angular.copy($s.report);

					_.set(reportData,'reviewDraftRptJson.reportDate', moment().format()); 
                    
					var actionItemGroups = _.cloneDeep($s.actionItemGroups);

					_.forEach(actionItemGroups,function(actionItemGroup,index,array){
						
						array[index] = _.omit(actionItemGroup,['AssociatedMetricsDisplay','$$hashKey']);

						 _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,index,array){
							  array[index] = _.omit(actionItem,'$$hashKey');
						 });
					 }); 

					 $s.publishActionItemGroups(actionItemGroups);

					_.set(reportData,'reviewDraftRptJson.actionItemGroups',actionItemGroups);
	
					var draftNotesJson = JSON.stringify(reportData);

					$s.isDirty = true;
					auditService.publishAudit(auditId,draftNotesJson,function(data){
					   var error = _.get(data,'Error');
					   if(error){
				    	  log.error(error);
						  $s.isDirty = false;
						  $s.updateInProgress = false;
						  $s.submitting = false;
						  log("publishReport: failed to publish report , update end");
			     	   }else{
				 		  // if the update was successfull and we are online we can then the data was synced and we can set isDirty false
				  if($s.isOnline){

		
					
					$s.isDirty = false;
					auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
						if (err) {
							log.error('error updateing isDirty flag: ' + err);
						}
				
						auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
						var auditlistItem = _.find(data,{AuditId: auditId});

						 log.info("publishReport: updating last synced date with : ");
						log.info(auditlistItem);

						 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
						if(!_.isUndefined(auditlistItem)){ 
							auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
								if (err) {
									log.error('error updating server with device data: ' + err);
								}
								$s.updateInProgress = false;
								log.info("publishReport: updated audit sync date after audit publish, update end");
								$window.location.href = "#/f360";
							});	 
						}else{
							log.info("publishReport: could not find audit indexedDB , update end");
							$s.updateInProgress = false;
							$s.submitting = false;
						
						}

					});
				  });
				}else{
					auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
						if (err) {
							log.error('error updateing isDirty flag: ' + err);
						}
						$s.updateInProgress = false;
						log.info("publishReport: offline and updated is dirty  flag , update end");
						$window.location.href = "#/f360";
					});
				}			
			   }  
					});
					
				}else{
					if(!_.isEqual($s.currentTopAnchor,"")){
						$s.scrollToTopError();
					 }
				}

			}
			$s.scrollToTopError = function(){
				$location.hash($s.currentTopAnchor);
			    $anchorScroll();
			}

			$s.addQuestionCategories = function(){
				//test interval 22
				var firstIntervalStartIndex = 2;
				var secondIntervalStartIndex = 25;
				var thirdIntervalStartIndex = 48;
				var fourthIntervalStartIndex = 71;
				var fifthIntervalStartIndex = 94;
				var sixthIntervalStartIndex = 117;
	
				_.forEach($s.auditQuestions,function(question){
					switch(true){
						case  (question.QuestionId >= 2 && question.QuestionId < 25):
						  _.set(question,'category','Cow Comfort');
						break;
						case (question.QuestionId >= 25 && question.QuestionId < 48):
							_.set(question,'category','Data Quality');
							break;
						case (question.QuestionId >= 48 && question.QuestionId < 71):
							_.set(question,'category','Fertility');
							break;
						case (question.QuestionId >= 71 && question.QuestionId < 94):
							_.set(question,'category','Nutrition');
							break;		
						case (question.QuestionId >= 94 && question.QuestionId < 117):
							_.set(question,'category','Personnel');
							break;
						case (question.QuestionId >= 117 && question.QuestionId < 140):
							_.set(question,'category','Transition Cow');
							break;
						case (question.QuestionId >= 141):
							_.set(question,'category','Unassigned');
							break;		
	
					}
				});
				
			}

		function loadActionItemGroupsAndItems(){
             _.set(testActionItemGroup,'associatedMetrics',
			     _.pluck(testAssociatedMetrics,'name').join(",") 	
			);

			 _.set(testActionItemGroup,'actionItems',testActionItems);
		
			 $s.actionItemGroups.push(testActionItemGroup);

			 var testActionItemGroup2 = _.cloneDeep(testActionItemGroup);

			 _.set(testActionItemGroup2,'actionItemGroupKey',"Cow Comfort");

			$s.actionItemGroups.push(testActionItemGroup2);

			$s.people = _.cloneDeep(testPeople);
		}	

		function orderAdditionalComments(){
			var orderedComments = [];
			var comments = _.get($s.report,'resultsWriteRptJson.comments',[]);
			var orderedCodeFileQuestionOrders = _.sortByOrder(_.cloneDeep($s.codeFileQuestionOrders),["dropDownSeq"],["asc"]);
			 _.forEach(orderedCodeFileQuestionOrders,function(codeFileOrderItem){
                   var commentObj = _.find(comments,{category: _.get(codeFileOrderItem,'code')});
				   if(!_.isUndefined(commentObj)){
					   orderedComments.push(commentObj);
				   }
			});

			if(!_.isEmpty(orderedComments)){
				_.set($s.report,'resultsWriteRptJson.comments',orderedComments);
			}
		} 

		function loadReportData(){
			const loadReportDataPromise = $q.defer();	
			perfMetricSvc.startTiming("Page:F360ReviewDraftReportGetIndexedDBReviewResultsAndDraft:Request");
			auditService.getIndexedDBReviewResultsAndDraft(self.auditId, $s.performanceContext, function getIndexedDBReviewResultsAndDraft(err, data) {
				perfMetricSvc.endTiming("page","Page:F360ReviewDraftReportGetIndexedDBReviewResultsAndDraft:Request", $s.performanceContext);
				if (err) {
					log.error('error getting F360 Review Results And Draft Data: ' + err);
					MSF.confirmation.danger(err,false);
				}
				perfMetricSvc.startTiming("Page:F360ReviewDraftReport:Build");
				if (data && data.length) {
					try{
					  $s.reportData =	JSON.parse(data);
					}catch(e){
						console.log("failed to parse report date");
					}
	
					if (!window.navigator.onLine) {
						$s.$apply();
					}
				}

				     perfMetricSvc.startTiming("Page:F360ReviewDraftReportGetIndexedDBOverViewList:Request");
					 auditService.getIndexedDBOverViewList(self.auditId, $s.performanceContext, function getIndexedDBOverViewList(err, data) {
						perfMetricSvc.endTiming("page","Page:F360ReviewDraftReportGetIndexedDBOverViewList:Request", $s.performanceContext);
						if (err) {
							log.error('error getting F360 Over View List: ' + err);
							MSF.confirmation.danger(err,false);
						}
						if (data && data.length) {
							$s.overViewList = data;
							for (let index = 0; index < $s.overViewList.length; index++) {
								$s.overViewList[index].AnswerCnt = 0;
								$s.overViewList[index].QuestionCnt = 0;
							}
							if (!window.navigator.onLine) {
								$s.$apply();
							}
						}

							perfMetricSvc.startTiming("Page:F360ReviewDraftReportGetIndexedDBQuestionList:Request");
							auditService.getIndexedDBQuestionList(auditId, $s.performanceContext, function getIndexedDBQuestionList(err, data) {
							perfMetricSvc.endTiming("page","Page:F360ReviewDraftReportGetIndexedDBQuestionList:Request", $s.performanceContext);
							if (err) {
								log.error('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
							}
							
							if (data && data.length) {
								var arrQuestion = [];
								var parseDataQuestion = JSON.parse(data);
								var questionDetailsJson = parseDataQuestion.QuestionsJson;
							
								for (let i = 0; i < questionDetailsJson.length; i++) {
									arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
								}
								// we need to order the questions here in the ux because the questions come from a JSON field
								// intead their own records in a table.
								$s.auditQuestions = _.sortByOrder(_.reject(arrQuestion,function(question){ return _.includes(["BODYSCORES","LAMESCORES"],_.get(question,'Section'))}),['SortOrder'],['asc']);

							

								perfMetricSvc.startTiming("Page:F360ReviewDraftReportGetIndexedDBAnswerList:Request");
								auditService.getIndexedDBAnswerList(auditId, $s.performanceContext, function getIndexedDBAnswerList(err, data) {
									perfMetricSvc.endTiming("page","Page:F360ReviewDraftReportGetIndexedDBAnswerList:Request", $s.performanceContext);
									if (err) {
										console.log('error getting F360 Over View List: ' + err);
										MSF.confirmation.danger(err,false);
									} 
									if (data && data.length) {
										try{
										 $s.auditAnswers = JSON.parse(data);
										}catch(e){
										  log.error("failed to parse answer list json : "+_.get(e,'message'," "));
										}
									 
									 
									 } else {
										$s.auditAnswers = [];
									 }

								    //if the not applicable question is checked we have to exclude certain questions including the NA question itself. 
								    removeExcludedQuestions();
	
									_.forEach($s.auditQuestions,function(question,index){
										var answer = _.get(_.find($s.auditAnswers,{QuestionId: question.QuestionId}),'AnswerDetailsJson');
										if(!_.isUndefined(answer)){
											var questionWithAnswer = _.cloneDeep(question);
											_.set(questionWithAnswer,'Answer',_.cloneDeep(answer));
											$s.auditQuestionsWithAnswers.push(questionWithAnswer);
										}else{
											console.error(`question with id of ${question.QuestionId} was missing its answer in loadReportData with an index value of ${index} in $s.auditQuestions `);
										}
								    });
							   		
									$s.$applyAsync(function(){
										buildStructuredQuestionsAndAnswers();
										loadPieCharts();
										loadBarCharts();
										loadFollowupItems();
										buildReportData();
										orderAdditionalComments();
										perfMetricSvc.endTiming("page","Page:F360ReviewDraftReport:Build", $s.performanceContext);
										loadReportDataPromise.resolve();
									});
	
								});
	
							} 
						});
					});
				});
				return loadReportDataPromise.promise;
			}

		

			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						  $s.checkF360SyncStatus().then(function(){
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
						
						  });
					  } 
				 }
				 
			 });

			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();
				if ($s.isOnline && $s.updateInProgress === false) {


					
					log.info("checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){
						
						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}

						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					     //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
						 if(	$s.updateInProgress === true){
							log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
							syncStatusPromise.reject(true);
							   return;
						   }

					   log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   perfMetricSvc.startTiming("Page:F360ReviewDraftReportGetSyncStatus:Request");
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, $s.performanceContext, function getF360SyncStatus(err, data) {
								perfMetricSvc.endTiming("page","Page:F360ReviewDraftReportGetSyncStatus:Request", $s.performanceContext);
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}

								  //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								  if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									   return;
								   }
								
								if (data) {
									self.isSync = true;
								
									var syncData = data;	

									if(!_.isUndefined(syncData)){
										log.info("checkedSync: synce data returned with");
										log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														log.info("checkedSync: updating last synced date with : ");
														log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																syncStatusPromise.resolve(true);
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													syncStatusPromise.resolve(true);
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										self.isSync = false;
										syncStatusPromise.resolve(true);
									}

								} else {
									self.isSync = false;
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
					self.isSync = false;
					syncStatusPromise.resolve(true);
				}
				return syncStatusPromise.promise;
			}
			function cleanupChart(chart, chartContainerId){
				if(!chart){
					console.warn('Could not cleanup chart, chart is not defined');
					return;
				}
				try {
					// Kill hidden resize monitor div
					const monitor = chart.canvas?.parentNode?.querySelector('.chartjs-size-monitor');
					monitor?.remove();

					// Destroy Chart instance and internal bindings
					chart.destroy();

					// Remove DOM canvas node
					chart.canvas?.remove();

					// Null all Chart object references
					chart.canvas = null;
					chart.ctx = null;
					chart.config = null;
					chart.scales = null;
					chart.$context = null;
					if (chart.chartArea) {
						chart.chartArea = null;
					}
				} catch (e) {
					console.warn('Error cleaning up chart: ', e);
				}

				// Remove any jQuery-bound handlers (if any were used)
        		$(chartContainerId).off();
			}

			$s.$on("$destroy", function() {
		
				deregOnFarmChange();
				deregOnlineCheckWatch();

				// clean up charts 
				cleanupChart($s.overallSummaryPieChart.chart, '#overallSummaryPieChart');
				cleanupChart($s.categoryBarChart.chart, '#categoryBarChart');
				$s.overallSummaryPieChart = null;
				$s.sectionBarChart = null;
				$s.categoryBarChart = null;
				$s.peformanceContext = null;
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});
			MSF.ready(function onMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId',null));
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				try{
						var actionItemGroupTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ACTITMGRP"}),'detailsJson'));
						var  maxActionItemGroupTemplateApiVer = _.max(
							_.map(actionItemGroupTemplateDetailsJsonArray,function(actionItemGroupTmplDetailsVersion){
								var apiVerNumStr = _.get(actionItemGroupTmplDetailsVersion,'apiVersion').replace("v","");
								return parseFloat(apiVerNumStr);
							})
						); 
						
						$s.actionItemGroupTmpl =  _.get(_.find(actionItemGroupTemplateDetailsJsonArray,{apiVersion:`v${maxActionItemGroupTemplateApiVer}`}),'template');

					}catch(e){
						log.info("Review Draft Page: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
					}

					try{
						var actionItemTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ACTITM"}),'detailsJson'));
						var  maxActionItemTemplateApiVer = _.max(
							_.map(actionItemTemplateDetailsJsonArray,function(actionItemTmplDetailsVersion){
								var apiVerNumStr = _.get(actionItemTmplDetailsVersion,'apiVersion').replace("v","");
								return parseFloat(apiVerNumStr);
							})
						); 
						
						$s.actionItemTmpl =  _.get(_.find(actionItemTemplateDetailsJsonArray,{apiVersion:`v${maxActionItemTemplateApiVer}`}),'template');

					}catch(e){
						log.info("Review Draft: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
					}

					$s.codeFileCurrentF360CategoryApiVersions = _.map(_.filter($s.codeFile,{codeType: "CURRENTAPIVERSIONS",code:"F360CATEGORY"}),function(codeFileItem){
							var detailsJson = _.get(codeFileItem,'detailsJson','[]');
							try{
								var detailsJsonArray = JSON.parse(detailsJson);
								_.set(codeFileItem,'detailsJson',detailsJsonArray);
								return codeFileItem;
							}catch(e){
								log.error("Falied To parse F360 Category Api Version in codeFileCurrentF360CategoryApiVersions");
								return {};
							}           
					});
						$s.currentF360CategoryApiVersion = _.get( $s.codeFileCurrentF360CategoryApiVersions	,'[0].detailsJson[0].value','v2.0');
			
						$s.codeFileQuestionSections = _.map(_.filter($s.codeFile,{codeType: "F360SECTION"}),function(codeFileSection){
							var detailsJson = _.get(codeFileSection,'detailsJson','[]');
							try{
								var detailsJsonArray = JSON.parse(detailsJson);
								_.set(codeFileSection,'detailsJson',detailsJsonArray);
								return codeFileSection;
							}catch(e){
								log.error("Falied To parse F36Section DetailsJson in codeFileQuestionSections");
								return {};
							}           
							});
							$s.codeFileQuestionSectionSubheadings = _.map($s.codeFileQuestionSections,function(codeFileSection){
							try{
			
								var sectionSubheadings = _.get(codeFileSection,'detailsJson[0].subHeadings',[]);
			
			
			
								return _.extend( 
									{sectionCode: _.get(codeFileSection,'code')},
									{sectionSubheadings: sectionSubheadings}
								);
			
							}catch(e){
								log.error("Falied To parse F36Section DetailsJson");
								return {};
							}
						}) ; 
			
						$s.codeFileQuestionCategories = _.filter(_.map(_.filter($s.codeFile,{codeType: "F360CATEGORY"}),function(codeFileCategory){
										var detailsJson = _.get(codeFileCategory,'detailsJson','[]');
										try{
											var detailsJsonArray = JSON.parse(detailsJson);
											_.set(codeFileCategory,'detailsJson',detailsJsonArray);
											return codeFileCategory;
										}catch(e){
											log.error("Falied To parse F360Category DetailsJson in codeFileQuestionCategories ");
											return {};
										}
						}), function(codeFileQuestionCategory){
							
														var categoryApiVersion = _.get(codeFileQuestionCategory,'detailsJson[0].apiVersion');
														if(_.isEqual(categoryApiVersion,$s.currentF360CategoryApiVersion)){
															return codeFileQuestionCategory;
														}
													});
						$s.codeFileQuestionSubCategories = _.map($s.codeFileQuestionCategories,function(codeFileCategory){
								try{
			
									var subCategories = _.get(codeFileCategory,'detailsJson[0].SubCategories',[]);
			
			
			
									return _.extend( 
										{categoryCode: _.get(codeFileCategory,'code')},
										{subCategories: subCategories}
									);
			
								}catch(e){
									log.error("Falied To parse F360Category DetailsJson");
									return {};
								}
						}) ; 
			
						$s.codeFileQuestionOrders = _.map(_.filter($s.codeFile,{codeType: "F360REPORTORDER"}),function(codeFileQuestionOrder){
							var detailsJson = _.get(codeFileQuestionOrder,'detailsJson','[]');
							try{
								var detailsJsonArray = JSON.parse(detailsJson);
								_.set(codeFileQuestionOrder,'detailsJson',detailsJsonArray);
								return codeFileQuestionOrder;
							}catch(e){
								log.error("Falied To parse F360 Order DetailsJson in codeFileQuestionOrders ");
								return {};
							}
							});
							$s.codeFileQuestionSubtitles = _.map($s.codeFileQuestionOrders,function(codeFileQuestionOrder){
							try{
			
							var subtitles = _.get(codeFileQuestionOrder,'detailsJson[0].subTitles',[]);
			
			
			
							return _.extend( 
										{orderCode: _.get(codeFileQuestionOrder,'code')},
										{subtitles: subtitles}
									);
			
							}catch(e){
								log.error("Falied To parse F360 Order DetailsJson");
								return {};
							}
						}) ; 
			

					$s.codeFileActionItemGroups = _.filter($s.codeFile, { codeType: "ACTIONITEMGROUP" });

					$s.codeFileActionItemGroupMetrics = _.filter($s.codeFile, { codeType: "ACTIONITEMMETRIC" });

						// add dispaly version of categories for comments in $s.report
						_.forEach($s.report.resultsWriteRptJson.comments,function(comment){
							var categoryDisplayValue = _.get(_.find($s.codeFileQuestionCategories,{code: comment.category}),'codeValue');
							_.set(comment,'categoryDisplay',categoryDisplayValue);
						});

                // transitioning to this page from Write Results leave the user at the bottom of the page
				// so we need to scroll to the top of the page
				MSF.waitForElm('#pageHeaderContainer').then(function(){
					var animationTargetElm = $('#site-body-content');
					animationTargetElm.animate({ scrollTop: 0 }, 0);
				});

				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion($s.performanceContext).then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });

				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						perfMetricSvc.startTiming("Page:F360ReviewDraftReport:Render");
					 	loadCurrentHerd(() => {
							loadReportData().then(() => {
								perfMetricSvc.markPageReady("Page:F360ReviewDraftReport:Render", $s.performanceContext);
							});
						 });			
						
					});

				});
			
			});
		}
	]);
})();
